<!-- @format -->

<template>
	<border-box>
		<div class="bookList">
			<div class="title"> 运维通讯录 </div>
			<div class="list">
				<template v-if="tableData.length > 0">
					<el-carousel
						height="100%"
						trigger="click"
						:autoplay="false"
						indicator-position="outside"
						:arrow="tableData.length > 1 ? 'always' : 'never'"
					>
						<el-carousel-item v-for="item in tableData" :key="item">
							<div class="item">
								<div class="detail date">
									<span class="key">值班日期:</span>
									<span class="value">{{ item.zbrq }}</span>
								</div>
								<div class="detail user">
									<span class="key">值班人员:</span>
									<span class="value">{{ item.zbry }}</span>
								</div>
								<div class="detail phone">
									<span class="key">值班电话:</span>
									<span class="value">{{ item.zbdh }}</span>
								</div>
								<div class="detail user">
									<span class="key">值班说明:</span>
									<span class="value">
										<el-tooltip class="box-item" effect="dark" :content="item.zbsm">
											{{ item.zbsm }}
										</el-tooltip>
									</span>
								</div>
							</div>
						</el-carousel-item>
					</el-carousel>
				</template>
				<template v-else>
					<div class="nodata">暂无数据</div>
				</template>
			</div>
		</div>
		<div v-show="isWorkbenchedit" class="delEdit">
			<el-icon @click="delEdit"><icon-ant-design:delete-outlined /></el-icon>
		</div>
	</border-box>
</template>

<script setup name="noticeList">
	import { ref } from 'vue';
	import dayjs from 'dayjs';
	import borderBox from './border-box.vue';
	import { getBookList } from '@/api/powercess/workbench';
	const emit = defineEmits(['deletePanelItemEvent']);
	const props = defineProps({
		isHeight: {
			type: [Boolean],
		},
		isWorkbenchedit: {
			type: [Boolean],
		},
		id: {
			type: [Number, String],
		},
	});

	const tableData = ref([]);

	function delEdit() {
		emit('deletePanelItemEvent', props.id);
	}
	const getData = async () => {
		const nowDate = dayjs().format('YYYY-MM-DD');
		const tomorrowDate = dayjs(nowDate).add(1, 'day').format('YYYY-MM-DD');

		const res = await getBookList({
			designerId: 'cdd5ccdfd0d749e79127185dfff576da',
			fieldMap: [{ '$start$.zbrq': `${nowDate} 00:00`, '$end$.zbrq': `${tomorrowDate} 00:00` }],
		});
		tableData.value = res;
	};
	getData();
</script>

<style scoped lang="scss">
	// @import '@/assets/styles/base/base-variables.module.scss';

	.delEdit {
		position: absolute;
		top: 20px;
		right: 25px;
		// font-size: $app-fontsize-title;

		.el-icon {
			// color: $theme-workbench-icon-color;
			cursor: pointer;
		}
	}

	.bookList {
		height: 100%;

		.title {
			font-weight: 600;
			font-size: 16px;
			color: #ffffff;
			line-height: 20px;
			text-align: left;

			&::before {
				content: '';
				display: inline-block;
				width: 3px;
				height: 18px;
				background: #5eebff;
				border-radius: 2px;
				margin-right: 5px;
				vertical-align: middle;
				margin-top: -4px;
			}
		}

		.list {
			height: calc(100% - 10px);
			padding: 10px;
			overflow: auto;

			:deep(.el-carousel__indicators--horizontal) {
				display: none;
			}

			:deep(.el-carousel--horizontal) {
				height: 100%;
			}

			:deep(.el-carousel__item) {
				display: flex;
				align-items: center;
				justify-content: center;
			}

			:deep(.el-carousel__arrow) {
				font-size: 24px;
			}

			:deep(.el-carousel__arrow--left) {
				left: 0px;
			}

			:deep(.el-carousel__arrow--right) {
				right: 0px;
			}

			.nodata {
				font-size: 16px;
				color: #ffffff;
				text-align: center;
			}

			.item {
				padding: 0 60px;
				width: 100%;

				.detail {
					// background: url('@/assets/images/book-bg.png') no-repeat;
					background-size: 100% 100%;
					height: 60px;
					margin-bottom: 15px;
					padding: 0 32px;
					line-height: 60px;

					&:last-child {
						margin-bottom: 0;
					}

					.key,
					.value {
						font-weight: 400;
						font-size: 16px;
						color: #ffffff;
						display: inline-block;
						margin-right: 10px;
						height: 100%;
						overflow: hidden;
					}

					.value {
						color: #5eebff;
						text-overflow: ellipsis;
						white-space: nowrap;
						width: 70%;
					}

					&.date,
					&.user,
					&.phone {
						&::before {
							content: '';
							display: inline-block;
							width: 24px;
							height: 24px;
							margin-right: 10px;
							vertical-align: top;
							margin-top: 18px;
						}
					}

					&.date {
						&::before {
							// background: url('@/assets/images/book-date.png') no-repeat;
							background-size: 100% 100%;
						}
					}

					&.user {
						&::before {
							// background: url('@/assets/images/book-user.png') no-repeat;
							background-size: 100% 100%;
						}
					}

					&.phone {
						&::before {
							// background: url('@/assets/images/book-phone.png') no-repeat;
							background-size: 100% 100%;
						}
					}
				}
			}
		}
	}
</style>
